export default __webpack_public_path__ + "static/media/weather-bg.4a93e155.webp";